export type DeviceKind = 'desktop' | 'mobile' | 'tablet' | 'unknown';

export type DeviceSummary = {
  browser: string;
  os: string;
  device: DeviceKind;
  label: string;
};

/** Turn a raw User-Agent into a short "Chrome on macOS" line. No extra dependency. */
export function describeUserAgent(ua: string | null | undefined): DeviceSummary {
  if (!ua?.trim()) return { browser: 'Unknown browser', os: 'Unknown device', device: 'unknown', label: 'Unknown device' };

  const os =
    /iPad/.test(ua) || (/Macintosh/.test(ua) && /Mobile/.test(ua)) ? 'iPadOS'
    : /iPhone|iPod/.test(ua) ? 'iOS'
    : /Android/.test(ua) ? 'Android'
    : /CrOS/.test(ua) ? 'ChromeOS'
    : /Mac OS X/.test(ua) ? 'macOS'
    : /Windows NT/.test(ua) ? 'Windows'
    : /Linux/.test(ua) ? 'Linux'
    : 'Unknown OS';

  const browser =
    /Edg\//.test(ua) ? 'Edge'
    : /OPR\/|Opera/.test(ua) ? 'Opera'
    : /Firefox\//.test(ua) ? 'Firefox'
    : /Chrome\//.test(ua) || /CriOS\//.test(ua) ? 'Chrome'
    : /Safari\//.test(ua) ? 'Safari'
    : 'Unknown browser';

  const device: DeviceKind =
    /iPad|Tablet/.test(ua) || (/Android/.test(ua) && !/Mobile/.test(ua)) ? 'tablet'
    : /Mobi|iPhone|iPod|Android/.test(ua) ? 'mobile'
    : os === 'Unknown OS' && browser === 'Unknown browser' ? 'unknown'
    : 'desktop';

  return { browser, os, device, label: `${browser} on ${os}` };
}
